import { ArrowLeft, GalleryVerticalEnd } from "lucide-react";

import { TextPreviewLoading } from "@/modules/mine/components/text-preview-loading";

export function ItemDetailPageLoading() {
  return (
    <div className="flex h-svh flex-col overflow-hidden bg-background text-foreground">
      <header className="shrink-0 border-b border-border/50 bg-background">
        <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:px-8">
          <div className="flex items-center gap-2 font-semibold tracking-tight">
            <span className="flex size-7 items-center justify-center rounded-lg bg-foreground text-background">
              <GalleryVerticalEnd className="size-4" />
            </span>
            Pinbox
          </div>
          <div className="flex items-center gap-2 text-sm">
            <ArrowLeft className="size-4" />
            返回 Pinbox
          </div>
        </div>
      </header>
      <main className="min-h-0 flex-1 overflow-hidden">
        <TextPreviewLoading />
      </main>
    </div>
  );
}
